module Tapas.Bindings {
    export class GetQuantityPrices {
        public init(element: any, valueAccessor: () => any, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;

            //TODO: Rewrite from jQuery
            var ele = $(element);
			
			ele.click(function () {
				if (ele.hasClass("loadQuantity")) {
                    var id = "productid=" + ele.parent().parent().find(".price").data("productid");
                    $.ajax({
                        method: "POST",
                        dataType: "json",
                        url: "/Handlers/Firstweb.ERP.PriceCache.ashx?cmd=getquantityprices",
                        data: id
                    })
                    .done(function (json) {
                        if (json.ERPStatus.Success) {
                            $.each(json.Data, function (key, data) {
                                ele.parent().find(".dropdown-menu li").remove();
                                ele.parent().find(".dropdown-menu").append("<li class='quantityPrice' ftw-quantity='" + data.Quantity + "'>" + data.Quantity + " " + ele.attr("ftw-unit") + " " + data.NettoPrice + " " + ele.attr("ftw-priceperunit") + "</li>").removeClass("load-drop");
                                ele.removeClass("loadQuantity");
                            });

							$(".quantityPrice").click(function () {
								$(this).parent().parent().parent().find("input.quantity").val($(this).attr("ftw-quantity"));
								$(this).parent().parent().parent().parent().find(".addToCart").attr("ftw-quantity", $(this).attr("ftw-quantity"));
							});
                        }
                    });
                }
			});
        }
    }
    ko.bindingHandlers['getQuantityPrices'] = new GetQuantityPrices();
}